import {Component, Input, OnInit} from '@angular/core';
import {TrafficLightRange} from '@models/machine/traffic-light/traffic-light-range';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'scitis-admin-traffic-light-element',
    templateUrl: './traffic-light-element.component.html',
    styleUrls: ['./traffic-light-element.component.scss'],
    standalone: false
})
export class TrafficLightElementComponent implements OnInit {
  @Input()
  kind: string = '';
  @Input()
  config: TrafficLightRange = new TrafficLightRange();
  @Input()
  isHigherThanAdmin: boolean = true;

  public headerHaloClass: string = '';
  public headerText: string = '';
  public headerTitle: string = '';

  constructor(private translate: TranslateService) {


  }

  setIsRange(range: boolean) {
    if (!this.config) {
      return;
    }
    this.config.range = range;
  }

  ngOnInit(): void {
    switch (this.kind) {
      case  'FAILURE': {
        this.headerHaloClass = 'badge-danger';
        this.headerText = this.translate.instant('Malfunction');
        this.headerTitle = this.translate.instant('Machine malfunction');
        break;
      }
      case 'WARNING': {
        this.headerHaloClass = 'badge-warning';
        this.headerText = this.translate.instant('Warning');
        this.headerTitle = this.translate.instant('Machine Warning or error-free switch off');
        break;
      }
      case 'RUNNING': {
        this.headerHaloClass = 'badge-success';
        this.headerText = this.translate.instant('Running');
        this.headerTitle = this.translate.instant('Machine operating faultlessly');
        break;
      }
    }

  }
}
